import { render, staticRenderFns } from "./addContractFamilyRelation.vue?vue&type=template&id=6a5eadcb&scoped=true"
import script from "./addContractFamilyRelation.vue?vue&type=script&lang=js"
export * from "./addContractFamilyRelation.vue?vue&type=script&lang=js"
import style0 from "./addContractFamilyRelation.vue?vue&type=style&index=0&id=6a5eadcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5eadcb",
  null
  
)

export default component.exports